module.exports = __webpack_public_path__ + "static/media/people12.d7010216.jpeg";